"use strict";
// This file is generated by devtools.
// Do not edit this file directly.
Object.defineProperty(exports, "__esModule", { value: true });
exports.validator = exports.vaccinationTypeMessages = exports.VaccinationType = void 0;
const schema_1 = require("../../../../../schema");
var VaccinationType;
(function (VaccinationType) {
    VaccinationType["COVID_VACCINATION_NO"] = "covid_vaccination_no";
    VaccinationType["COVID_VACCINATION_UNKNOWN"] = "covid_vaccination_unknown";
    VaccinationType["COVID_VACCINATION_ABDALA"] = "covid_vaccination_Abdala";
    VaccinationType["COVID_VACCINATION_CHINESE_ACADEMY_OF_MEDICAL_SCIENCES"] = "covid_vaccination_Chinese_Academy_of_Medical_Sciences";
    VaccinationType["COVID_VACCINATION_CONVIDECIA"] = "covid_vaccination_Convidecia";
    VaccinationType["COVID_VACCINATION_CORBEVAX"] = "covid_vaccination_Corbevax";
    VaccinationType["COVID_VACCINATION_CORONA_VAC"] = "covid_vaccination_CoronaVac";
    VaccinationType["COID_VACCINATION_COVAX_19"] = "coid_vaccination_COVAX-19";
    VaccinationType["COVID_VACCINATION_COVAXIN"] = "covid_vaccination_Covaxin";
    VaccinationType["COVID_VACCINATION_COVIRAN_BAREKAT"] = "covid_vaccination_COVIran_Barekat";
    VaccinationType["COVID_VACCINATION_COVI_VAC"] = "covid_vaccination_CoviVac";
    VaccinationType["COVID_VACCINATION_CO_VLP"] = "covid_vaccination_CoVLP";
    VaccinationType["COVID_VACCINATION_EPI_VAC_CORONA"] = "covid_vaccination_EpiVacCorona";
    VaccinationType["COVID_VACCINATION_EVUSHELD"] = "covid_vaccination_Evusheld";
    VaccinationType["COVID_VACCINATION_FAKHRAVAC"] = "covid_vaccination_FAKHRAVAC";
    VaccinationType["COVID_VACCINATION_JANSSEN"] = "covid_vaccination_Janssen";
    VaccinationType["COVID_VACCINATION_MEDIGEN"] = "covid_vaccination_Medigen";
    VaccinationType["COVID_VACCINATION_MINHAI"] = "covid_vaccination_Minhai";
    VaccinationType["COVID_VACCINATION_MODERNA"] = "covid_vaccination_Moderna";
    VaccinationType["COVID_VACCINATION_NOORA"] = "covid_vaccination_Noora";
    VaccinationType["COVID_VACCINATION_NOVAVAX"] = "covid_vaccination_Novavax";
    VaccinationType["COVID_VACCINATION_OXFORD_ASTRA_ZENECA"] = "covid_vaccination_Oxford\u2013AstraZeneca";
    VaccinationType["COVID_VACCINATION_PFIZER_BIO_NTECH"] = "covid_vaccination_Pfizer\u2013BioNTech";
    VaccinationType["COVID_VACCINATION_QAZ_COVID_IN"] = "covid_vaccination_QazCovid-in";
    VaccinationType["COVID_VACCINATION_RAZI_COV_PARS"] = "covid_vaccination_Razi_Cov_Pars";
    VaccinationType["COVID_VACCINATION_SINOPHARM"] = "covid_vaccination_Sinopharm";
    VaccinationType["COVID_VACCINATION_SINOPHARM_NVSI"] = "covid_vaccination_Sinopharm_NVSI";
    VaccinationType["COVID_VACCINATION_SINOPHARM_WIBP"] = "covid_vaccination_Sinopharm_WIBP";
    VaccinationType["COVID_VACCINATION_SKYCOVIONE"] = "covid_vaccination_SKYCovione";
    VaccinationType["COVID_VACCINATION_SOBERANA_02"] = "covid_vaccination_Soberana_02";
    VaccinationType["COVID_VACCINATION_SOBERANA_PLUS"] = "covid_vaccination_Soberana_Plus";
    VaccinationType["COVID_VACCINATION_SPUTNIK"] = "covid_vaccination_Sputnik";
    VaccinationType["COVID_VACCINATION_SPUTNIK_LIGHT"] = "covid_vaccination_Sputnik_Light";
    VaccinationType["COVID_VACCINATION_TURKOVAC"] = "covid_vaccination_Turkovac";
    VaccinationType["COVID_VACCINATION_VLA2001"] = "covid_vaccination_VLA2001";
    VaccinationType["COVID_VACCINATION_ZIFIVAX"] = "covid_vaccination_Zifivax";
    VaccinationType["COVID_VACCINATION_ZY_CO_V_D6"] = "covid_vaccination_ZyCoV-D6";
})(VaccinationType || (exports.VaccinationType = VaccinationType = {}));
exports.vaccinationTypeMessages = {
    [VaccinationType.COVID_VACCINATION_NO]: {
        id: "ktx.transplantationScreening.medicalHistory.covid.covidVaccination.vaccinationType.COVID_VACCINATION_NO",
        defaultMessage: "Nincs COVID oltás"
    },
    [VaccinationType.COVID_VACCINATION_UNKNOWN]: {
        id: "ktx.transplantationScreening.medicalHistory.covid.covidVaccination.vaccinationType.COVID_VACCINATION_UNKNOWN",
        defaultMessage: "Ismeretlen COVID oltás"
    },
    [VaccinationType.COVID_VACCINATION_ABDALA]: {
        id: "ktx.transplantationScreening.medicalHistory.covid.covidVaccination.vaccinationType.COVID_VACCINATION_ABDALA",
        defaultMessage: "Abdala"
    },
    [VaccinationType.COVID_VACCINATION_CHINESE_ACADEMY_OF_MEDICAL_SCIENCES]: {
        id: "ktx.transplantationScreening.medicalHistory.covid.covidVaccination.vaccinationType.COVID_VACCINATION_CHINESE_ACADEMY_OF_MEDICAL_SCIENCES",
        defaultMessage: "Chinese Academy of Medical Sciences"
    },
    [VaccinationType.COVID_VACCINATION_CONVIDECIA]: {
        id: "ktx.transplantationScreening.medicalHistory.covid.covidVaccination.vaccinationType.COVID_VACCINATION_CONVIDECIA",
        defaultMessage: "Convidecia"
    },
    [VaccinationType.COVID_VACCINATION_CORBEVAX]: {
        id: "ktx.transplantationScreening.medicalHistory.covid.covidVaccination.vaccinationType.COVID_VACCINATION_CORBEVAX",
        defaultMessage: "Corbevax"
    },
    [VaccinationType.COVID_VACCINATION_CORONA_VAC]: {
        id: "ktx.transplantationScreening.medicalHistory.covid.covidVaccination.vaccinationType.COVID_VACCINATION_CORONA_VAC",
        defaultMessage: "CoronaVac"
    },
    [VaccinationType.COID_VACCINATION_COVAX_19]: {
        id: "ktx.transplantationScreening.medicalHistory.covid.covidVaccination.vaccinationType.COID_VACCINATION_COVAX_19",
        defaultMessage: "COVAX-19"
    },
    [VaccinationType.COVID_VACCINATION_COVAXIN]: {
        id: "ktx.transplantationScreening.medicalHistory.covid.covidVaccination.vaccinationType.COVID_VACCINATION_COVAXIN",
        defaultMessage: "Covaxin"
    },
    [VaccinationType.COVID_VACCINATION_COVIRAN_BAREKAT]: {
        id: "ktx.transplantationScreening.medicalHistory.covid.covidVaccination.vaccinationType.COVID_VACCINATION_COVIRAN_BAREKAT",
        defaultMessage: "COVIran Barekat"
    },
    [VaccinationType.COVID_VACCINATION_COVI_VAC]: {
        id: "ktx.transplantationScreening.medicalHistory.covid.covidVaccination.vaccinationType.COVID_VACCINATION_COVI_VAC",
        defaultMessage: "CoviVac"
    },
    [VaccinationType.COVID_VACCINATION_CO_VLP]: {
        id: "ktx.transplantationScreening.medicalHistory.covid.covidVaccination.vaccinationType.COVID_VACCINATION_CO_VLP",
        defaultMessage: "CoVLP"
    },
    [VaccinationType.COVID_VACCINATION_EPI_VAC_CORONA]: {
        id: "ktx.transplantationScreening.medicalHistory.covid.covidVaccination.vaccinationType.COVID_VACCINATION_EPI_VAC_CORONA",
        defaultMessage: "EpiVacCorona"
    },
    [VaccinationType.COVID_VACCINATION_EVUSHELD]: {
        id: "ktx.transplantationScreening.medicalHistory.covid.covidVaccination.vaccinationType.COVID_VACCINATION_EVUSHELD",
        defaultMessage: "Evusheld"
    },
    [VaccinationType.COVID_VACCINATION_FAKHRAVAC]: {
        id: "ktx.transplantationScreening.medicalHistory.covid.covidVaccination.vaccinationType.COVID_VACCINATION_FAKHRAVAC",
        defaultMessage: "FAKHRAVAC"
    },
    [VaccinationType.COVID_VACCINATION_JANSSEN]: {
        id: "ktx.transplantationScreening.medicalHistory.covid.covidVaccination.vaccinationType.COVID_VACCINATION_JANSSEN",
        defaultMessage: "Janssen"
    },
    [VaccinationType.COVID_VACCINATION_MEDIGEN]: {
        id: "ktx.transplantationScreening.medicalHistory.covid.covidVaccination.vaccinationType.COVID_VACCINATION_MEDIGEN",
        defaultMessage: "Medigen"
    },
    [VaccinationType.COVID_VACCINATION_MINHAI]: {
        id: "ktx.transplantationScreening.medicalHistory.covid.covidVaccination.vaccinationType.COVID_VACCINATION_MINHAI",
        defaultMessage: "Minhai"
    },
    [VaccinationType.COVID_VACCINATION_MODERNA]: {
        id: "ktx.transplantationScreening.medicalHistory.covid.covidVaccination.vaccinationType.COVID_VACCINATION_MODERNA",
        defaultMessage: "Moderna"
    },
    [VaccinationType.COVID_VACCINATION_NOORA]: {
        id: "ktx.transplantationScreening.medicalHistory.covid.covidVaccination.vaccinationType.COVID_VACCINATION_NOORA",
        defaultMessage: "Noora"
    },
    [VaccinationType.COVID_VACCINATION_NOVAVAX]: {
        id: "ktx.transplantationScreening.medicalHistory.covid.covidVaccination.vaccinationType.COVID_VACCINATION_NOVAVAX",
        defaultMessage: "Novavax"
    },
    [VaccinationType.COVID_VACCINATION_OXFORD_ASTRA_ZENECA]: {
        id: "ktx.transplantationScreening.medicalHistory.covid.covidVaccination.vaccinationType.COVID_VACCINATION_OXFORD_ASTRA_ZENECA",
        defaultMessage: "Oxford–AstraZeneca"
    },
    [VaccinationType.COVID_VACCINATION_PFIZER_BIO_NTECH]: {
        id: "ktx.transplantationScreening.medicalHistory.covid.covidVaccination.vaccinationType.COVID_VACCINATION_PFIZER_BIO_NTECH",
        defaultMessage: "Pfizer–BioNTech"
    },
    [VaccinationType.COVID_VACCINATION_QAZ_COVID_IN]: {
        id: "ktx.transplantationScreening.medicalHistory.covid.covidVaccination.vaccinationType.COVID_VACCINATION_QAZ_COVID_IN",
        defaultMessage: "QazCovid-in"
    },
    [VaccinationType.COVID_VACCINATION_RAZI_COV_PARS]: {
        id: "ktx.transplantationScreening.medicalHistory.covid.covidVaccination.vaccinationType.COVID_VACCINATION_RAZI_COV_PARS",
        defaultMessage: "Razi Cov Pars"
    },
    [VaccinationType.COVID_VACCINATION_SINOPHARM]: {
        id: "ktx.transplantationScreening.medicalHistory.covid.covidVaccination.vaccinationType.COVID_VACCINATION_SINOPHARM",
        defaultMessage: "Sinopharm"
    },
    [VaccinationType.COVID_VACCINATION_SINOPHARM_NVSI]: {
        id: "ktx.transplantationScreening.medicalHistory.covid.covidVaccination.vaccinationType.COVID_VACCINATION_SINOPHARM_NVSI",
        defaultMessage: "Sinopharm NVSI"
    },
    [VaccinationType.COVID_VACCINATION_SINOPHARM_WIBP]: {
        id: "ktx.transplantationScreening.medicalHistory.covid.covidVaccination.vaccinationType.COVID_VACCINATION_SINOPHARM_WIBP",
        defaultMessage: "Sinopharm WIBP"
    },
    [VaccinationType.COVID_VACCINATION_SKYCOVIONE]: {
        id: "ktx.transplantationScreening.medicalHistory.covid.covidVaccination.vaccinationType.COVID_VACCINATION_SKYCOVIONE",
        defaultMessage: "SKYCovione"
    },
    [VaccinationType.COVID_VACCINATION_SOBERANA_02]: {
        id: "ktx.transplantationScreening.medicalHistory.covid.covidVaccination.vaccinationType.COVID_VACCINATION_SOBERANA_02",
        defaultMessage: "Soberana 02"
    },
    [VaccinationType.COVID_VACCINATION_SOBERANA_PLUS]: {
        id: "ktx.transplantationScreening.medicalHistory.covid.covidVaccination.vaccinationType.COVID_VACCINATION_SOBERANA_PLUS",
        defaultMessage: "Soberana Plus"
    },
    [VaccinationType.COVID_VACCINATION_SPUTNIK]: {
        id: "ktx.transplantationScreening.medicalHistory.covid.covidVaccination.vaccinationType.COVID_VACCINATION_SPUTNIK",
        defaultMessage: "Sputnik"
    },
    [VaccinationType.COVID_VACCINATION_SPUTNIK_LIGHT]: {
        id: "ktx.transplantationScreening.medicalHistory.covid.covidVaccination.vaccinationType.COVID_VACCINATION_SPUTNIK_LIGHT",
        defaultMessage: "Sputnik Light"
    },
    [VaccinationType.COVID_VACCINATION_TURKOVAC]: {
        id: "ktx.transplantationScreening.medicalHistory.covid.covidVaccination.vaccinationType.COVID_VACCINATION_TURKOVAC",
        defaultMessage: "Turkovac"
    },
    [VaccinationType.COVID_VACCINATION_VLA2001]: {
        id: "ktx.transplantationScreening.medicalHistory.covid.covidVaccination.vaccinationType.COVID_VACCINATION_VLA2001",
        defaultMessage: "VLA2001"
    },
    [VaccinationType.COVID_VACCINATION_ZIFIVAX]: {
        id: "ktx.transplantationScreening.medicalHistory.covid.covidVaccination.vaccinationType.COVID_VACCINATION_ZIFIVAX",
        defaultMessage: "Zifivax"
    },
    [VaccinationType.COVID_VACCINATION_ZY_CO_V_D6]: {
        id: "ktx.transplantationScreening.medicalHistory.covid.covidVaccination.vaccinationType.COVID_VACCINATION_ZY_CO_V_D6",
        defaultMessage: "ZyCoV-D6"
    }
};
const vaccinationType = schema_1.Schema.singleChoice([
    schema_1.Schema.singleChoiceItem(VaccinationType.COVID_VACCINATION_NO)
        .interpretation({ vocab: "ktx", code: "covid_vaccination_no" })
        .tag({ vocab: "ktx", code: "covid_vaccination_type" }),
    schema_1.Schema.singleChoiceItem(VaccinationType.COVID_VACCINATION_UNKNOWN)
        .interpretation({ vocab: "ktx", code: "covid_vaccination_unknown" })
        .tag({ vocab: "ktx", code: "covid_vaccination_type" }),
    schema_1.Schema.singleChoiceItem(VaccinationType.COVID_VACCINATION_ABDALA)
        .interpretation({ vocab: "ktx", code: "covid_vaccination_Abdala" })
        .tag({ vocab: "ktx", code: "covid_vaccination_type" }),
    schema_1.Schema.singleChoiceItem(VaccinationType.COVID_VACCINATION_CHINESE_ACADEMY_OF_MEDICAL_SCIENCES)
        .interpretation({
        vocab: "ktx",
        code: "covid_vaccination_Chinese_Academy_of_Medical_Sciences"
    })
        .tag({ vocab: "ktx", code: "covid_vaccination_type" }),
    schema_1.Schema.singleChoiceItem(VaccinationType.COVID_VACCINATION_CONVIDECIA)
        .interpretation({ vocab: "ktx", code: "covid_vaccination_Convidecia" })
        .tag({ vocab: "ktx", code: "covid_vaccination_type" }),
    schema_1.Schema.singleChoiceItem(VaccinationType.COVID_VACCINATION_CORBEVAX)
        .interpretation({ vocab: "ktx", code: "covid_vaccination_Corbevax" })
        .tag({ vocab: "ktx", code: "covid_vaccination_type" }),
    schema_1.Schema.singleChoiceItem(VaccinationType.COVID_VACCINATION_CORONA_VAC)
        .interpretation({ vocab: "ktx", code: "covid_vaccination_CoronaVac" })
        .tag({ vocab: "ktx", code: "covid_vaccination_type" }),
    schema_1.Schema.singleChoiceItem(VaccinationType.COID_VACCINATION_COVAX_19)
        .interpretation({ vocab: "ktx", code: "coid_vaccination_COVAX-19" })
        .tag({ vocab: "ktx", code: "covid_vaccination_type" }),
    schema_1.Schema.singleChoiceItem(VaccinationType.COVID_VACCINATION_COVAXIN)
        .interpretation({ vocab: "ktx", code: "covid_vaccination_Covaxin" })
        .tag({ vocab: "ktx", code: "covid_vaccination_type" }),
    schema_1.Schema.singleChoiceItem(VaccinationType.COVID_VACCINATION_COVIRAN_BAREKAT)
        .interpretation({
        vocab: "ktx",
        code: "covid_vaccination_COVIran_Barekat"
    })
        .tag({ vocab: "ktx", code: "covid_vaccination_type" }),
    schema_1.Schema.singleChoiceItem(VaccinationType.COVID_VACCINATION_COVI_VAC)
        .interpretation({ vocab: "ktx", code: "covid_vaccination_CoviVac" })
        .tag({ vocab: "ktx", code: "covid_vaccination_type" }),
    schema_1.Schema.singleChoiceItem(VaccinationType.COVID_VACCINATION_CO_VLP)
        .interpretation({ vocab: "ktx", code: "covid_vaccination_CoVLP" })
        .tag({ vocab: "ktx", code: "covid_vaccination_type" }),
    schema_1.Schema.singleChoiceItem(VaccinationType.COVID_VACCINATION_EPI_VAC_CORONA)
        .interpretation({
        vocab: "ktx",
        code: "covid_vaccination_EpiVacCorona"
    })
        .tag({ vocab: "ktx", code: "covid_vaccination_type" }),
    schema_1.Schema.singleChoiceItem(VaccinationType.COVID_VACCINATION_EVUSHELD)
        .interpretation({ vocab: "ktx", code: "covid_vaccination_Evusheld" })
        .tag({ vocab: "ktx", code: "covid_vaccination_type" }),
    schema_1.Schema.singleChoiceItem(VaccinationType.COVID_VACCINATION_FAKHRAVAC)
        .interpretation({ vocab: "ktx", code: "covid_vaccination_FAKHRAVAC" })
        .tag({ vocab: "ktx", code: "covid_vaccination_type" }),
    schema_1.Schema.singleChoiceItem(VaccinationType.COVID_VACCINATION_JANSSEN)
        .interpretation({ vocab: "ktx", code: "covid_vaccination_Janssen" })
        .tag({ vocab: "ktx", code: "covid_vaccination_type" }),
    schema_1.Schema.singleChoiceItem(VaccinationType.COVID_VACCINATION_MEDIGEN)
        .interpretation({ vocab: "ktx", code: "covid_vaccination_Medigen" })
        .tag({ vocab: "ktx", code: "covid_vaccination_type" }),
    schema_1.Schema.singleChoiceItem(VaccinationType.COVID_VACCINATION_MINHAI)
        .interpretation({ vocab: "ktx", code: "covid_vaccination_Minhai" })
        .tag({ vocab: "ktx", code: "covid_vaccination_type" }),
    schema_1.Schema.singleChoiceItem(VaccinationType.COVID_VACCINATION_MODERNA)
        .interpretation({ vocab: "ktx", code: "covid_vaccination_Moderna" })
        .tag({ vocab: "ktx", code: "covid_vaccination_type" }),
    schema_1.Schema.singleChoiceItem(VaccinationType.COVID_VACCINATION_NOORA)
        .interpretation({ vocab: "ktx", code: "covid_vaccination_Noora" })
        .tag({ vocab: "ktx", code: "covid_vaccination_type" }),
    schema_1.Schema.singleChoiceItem(VaccinationType.COVID_VACCINATION_NOVAVAX)
        .interpretation({ vocab: "ktx", code: "covid_vaccination_Novavax" })
        .tag({ vocab: "ktx", code: "covid_vaccination_type" }),
    schema_1.Schema.singleChoiceItem(VaccinationType.COVID_VACCINATION_OXFORD_ASTRA_ZENECA)
        .interpretation({
        vocab: "ktx",
        code: "covid_vaccination_Oxford–AstraZeneca"
    })
        .tag({ vocab: "ktx", code: "covid_vaccination_type" }),
    schema_1.Schema.singleChoiceItem(VaccinationType.COVID_VACCINATION_PFIZER_BIO_NTECH)
        .interpretation({
        vocab: "ktx",
        code: "covid_vaccination_Pfizer–BioNTech"
    })
        .tag({ vocab: "ktx", code: "covid_vaccination_type" }),
    schema_1.Schema.singleChoiceItem(VaccinationType.COVID_VACCINATION_QAZ_COVID_IN)
        .interpretation({ vocab: "ktx", code: "covid_vaccination_QazCovid-in" })
        .tag({ vocab: "ktx", code: "covid_vaccination_type" }),
    schema_1.Schema.singleChoiceItem(VaccinationType.COVID_VACCINATION_RAZI_COV_PARS)
        .interpretation({
        vocab: "ktx",
        code: "covid_vaccination_Razi_Cov_Pars"
    })
        .tag({ vocab: "ktx", code: "covid_vaccination_type" }),
    schema_1.Schema.singleChoiceItem(VaccinationType.COVID_VACCINATION_SINOPHARM)
        .interpretation({ vocab: "ktx", code: "covid_vaccination_Sinopharm" })
        .tag({ vocab: "ktx", code: "covid_vaccination_type" }),
    schema_1.Schema.singleChoiceItem(VaccinationType.COVID_VACCINATION_SINOPHARM_NVSI)
        .interpretation({
        vocab: "ktx",
        code: "covid_vaccination_Sinopharm_NVSI"
    })
        .tag({ vocab: "ktx", code: "covid_vaccination_type" }),
    schema_1.Schema.singleChoiceItem(VaccinationType.COVID_VACCINATION_SINOPHARM_WIBP)
        .interpretation({
        vocab: "ktx",
        code: "covid_vaccination_Sinopharm_WIBP"
    })
        .tag({ vocab: "ktx", code: "covid_vaccination_type" }),
    schema_1.Schema.singleChoiceItem(VaccinationType.COVID_VACCINATION_SKYCOVIONE)
        .interpretation({ vocab: "ktx", code: "covid_vaccination_SKYCovione" })
        .tag({ vocab: "ktx", code: "covid_vaccination_type" }),
    schema_1.Schema.singleChoiceItem(VaccinationType.COVID_VACCINATION_SOBERANA_02)
        .interpretation({ vocab: "ktx", code: "covid_vaccination_Soberana_02" })
        .tag({ vocab: "ktx", code: "covid_vaccination_type" }),
    schema_1.Schema.singleChoiceItem(VaccinationType.COVID_VACCINATION_SOBERANA_PLUS)
        .interpretation({
        vocab: "ktx",
        code: "covid_vaccination_Soberana_Plus"
    })
        .tag({ vocab: "ktx", code: "covid_vaccination_type" }),
    schema_1.Schema.singleChoiceItem(VaccinationType.COVID_VACCINATION_SPUTNIK)
        .interpretation({ vocab: "ktx", code: "covid_vaccination_Sputnik" })
        .tag({ vocab: "ktx", code: "covid_vaccination_type" }),
    schema_1.Schema.singleChoiceItem(VaccinationType.COVID_VACCINATION_SPUTNIK_LIGHT)
        .interpretation({
        vocab: "ktx",
        code: "covid_vaccination_Sputnik_Light"
    })
        .tag({ vocab: "ktx", code: "covid_vaccination_type" }),
    schema_1.Schema.singleChoiceItem(VaccinationType.COVID_VACCINATION_TURKOVAC)
        .interpretation({ vocab: "ktx", code: "covid_vaccination_Turkovac" })
        .tag({ vocab: "ktx", code: "covid_vaccination_type" }),
    schema_1.Schema.singleChoiceItem(VaccinationType.COVID_VACCINATION_VLA2001)
        .interpretation({ vocab: "ktx", code: "covid_vaccination_VLA2001" })
        .tag({ vocab: "ktx", code: "covid_vaccination_type" }),
    schema_1.Schema.singleChoiceItem(VaccinationType.COVID_VACCINATION_ZIFIVAX)
        .interpretation({ vocab: "ktx", code: "covid_vaccination_Zifivax" })
        .tag({ vocab: "ktx", code: "covid_vaccination_type" }),
    schema_1.Schema.singleChoiceItem(VaccinationType.COVID_VACCINATION_ZY_CO_V_D6)
        .interpretation({ vocab: "ktx", code: "covid_vaccination_ZyCoV-D6" })
        .tag({ vocab: "ktx", code: "covid_vaccination_type" })
]);
exports.validator = schema_1.Schema.object()
    .default({})
    .sealed(true)
    .properties({ vaccinationType })
    .interpretation({ vocab: "ktx", code: "covid_vaccination" });
